<template>
  <div>
    <div class="title">推广人订单</div>
    <div class="total">累计推广订单{{ count }}单</div>
    <div class="project" v-for="item of orderLIst" :key="item.time">
      <div class="time">
        {{ item.time }}
        <div>本月累计推广{{ item.count }}单</div>
      </div>
      <div class="item" v-for="val of item.child" :key="val.order_id">
        <div class="head">
          <div class="img">
            <img :src="val.avatar" alt="" />
          </div>
          <div class="name">{{ val.nickname }}</div>
          <div class="money">
            返佣: <span>￥{{ val.number }}</span>
          </div>
        </div>
        <div class="product" v-for="pro of val.product" :key="pro.image">
          <div class="left">
            <img :src="pro.image" alt="" />
          </div>
          <div class="right">
            <div class="tip">{{ pro.store_name }}</div>
            <div class="price">￥{{ pro.price }}</div>
            <div class="num">X{{ pro.cart_num }}</div>
          </div>
        </div>
        <div class="order">
          <div class="order-box">
            <div><span>订单号: </span> {{ val.order_id }}</div>
            <div><span>下单时间: </span> {{ val.time }}</div>
          </div>
          <div class="old-price">
            共1件产品,总金额为<span>￥{{ val.total_price }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpreadOrder } from "@api/user";
export default {
  name: "BusinessOrder",
  data() {
    return {
      orderLIst: [],
      param: {
        page: 1,
        limit: 15
      },
      count: ""
    };
  },
  created() {
    this.getSpreadOrderList();
  },
  methods: {
    getSpreadOrderList() {
      getSpreadOrder(this.param).then(res => {
        this.orderLIst = res.data.list;
        this.count = res.data.count;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  text-align center
  font-size 16px
  line-height 40px
  border-bottom 1px solid #dbdbdb
  padding-bottom 10px
.total
  font-size 14px
  line-height 40px
.project
  margin-top 10px
  .time
    background #e9e9e9
    padding 5px
  .item
    margin-top 10px
    .head
      display flex
      align-items center
      margin-left 10px
      border-bottom 1px dashed #ddd
      padding-bottom 5px
      .img
        display flex
        width 30px
        height 30px
        border-radius 50%
        background red
        overflow hidden
        img
          width 100%
          height 100%
      .name
        margin-left 15px
        width 120px
      .money
        span
          font-size 16px
          color #fc4141
    .product
      display flex
      padding 10px 0 10px 50px
      .left
        width 100px
        height 100px
        background red
        img
          width 100%
          height 100%
      .right
        margin-left 20px
        width 400px
        .tip
          margin-top 5px
          font-size 16px
          color #666
        .price
          font-size 14px
          color #999
          margin-top 20px
          text-align right
        .num
          text-align right
          font-size 14px
          color #999
          margin-left 2px
          margin-top 5px
    .order
      margin-left 50px
      margin-right 420px
      padding-top 5px
      border-top 1px solid #ccc
      display flex
      justify-content space-between
      .order-box
        color #666
        span
          color #999
      .old-price
        font-weight 700
        span
          color #fc4141
</style>
